export const CLIENT_THESIS = {
  tag: "CLIENT DELIVERY // 06",
  status: "METRICS + REVENUE",
  headline: "What This Delivers to Your End Clients",
  insight:
    "Your clients value the leads you drive, but they renew when those leads become booked appointments and closed contracts. FractoLabs adds that revenue layer to every campaign you run.",
};

export const VALUE_TRANSLATION = {
  agencyLabel: "You still deliver",
  agencyMetrics: ["CTR", "Impressions", "Cost-per-click"],
  connectorLabel: "Layer 2: Revenue capture",
  clientLabel: "Plus, they also get",
  clientOutcomes: ["Booked appointments", "Closed contracts", "Cash in bank"],
};

export const DELIVERY_LANES_SECTION = {
  label: "Four delivery lanes",
};

export const CLIENT_BENEFITS = [
  {
    id: "speed",
    lane: "SPEED",
    code: "DV-01",
    title: "Instant Speed-to-Lead (The Midnight Safety Net)",
    shortOutcome:
      "Zero burned leads: capture high-ticket emergency contracts while competitors sleep.",
    problem:
      "40% of inbound leads manifest during off-hours, weekends, or storm emergencies. If your client doesn't respond within 5 minutes, the homeowner calls the next contractor on Google.",
    solution:
      "The AI Employee intercepts 100% of text, web, and chat inquiries in under 9 seconds, 24/7/365.",
    outcome:
      "Zero burned leads. Your client captures high-ticket emergency contracts while their competitors are asleep.",
  },
  {
    id: "calendar",
    lane: "CALENDAR",
    code: "DV-02",
    title: "Clean Calendar Automation (Zero Operational Friction)",
    shortOutcome:
      "Pre-filled calendar with fully vetted field inspections waiting at 9:00 AM.",
    problem:
      "Manual callbacks take hours or days. Managers tag back-and-forth trying to find a time slot, resulting in lead drop-offs.",
    solution:
      "The AI directly reads live crew availability via native CRM/Calendar integrations and guides the qualified user to select a precise arrival window.",
    outcome:
      "A predictable, automated sales pipeline. Your client's team wakes up to a calendar pre-filled with fully vetted field inspections.",
  },
  {
    id: "quality",
    lane: "QUALITY",
    code: "DV-03",
    title: "Protection Against \"Bad\" Leads (Strict Quality Control)",
    shortOutcome:
      "Estimators only drive to high-probability jobs that fit operations.",
    problem:
      "Field estimators waste time and fuel driving to dead-end properties that are out of service range, commercial units, or renters without owner consent.",
    solution:
      "The AI Employee executes an asynchronous 15-point verification script and Google Geocoding/Haversine validation before unlocking the booking engine.",
    outcome:
      "Maximized workforce efficiency. Your client's estimators only travel to high-probability, high-ticket residential assets that strictly fit their operations.",
  },
  {
    id: "brand",
    lane: "BRAND",
    code: "DV-04",
    title: "Absolute Brand Reputation Safety (Zero Hallucinations)",
    shortOutcome:
      "Cutting-edge automation with 0% corporate or legal risk.",
    problem:
      "Standard AI bots go off-script, guarantee fake legal pricing, or promise services the contractor doesn't provide, leading to bad reviews and complaints.",
    solution:
      "Backed by our strict, hard-gated Policy Engine, the digital employee operates purely on verified database facts and gracefully declines out-of-scope requests.",
    outcome:
      "Total peace of mind. Your client gets all the efficiency of cutting-edge automation with 0% corporate or legal risk.",
  },
];
